import { Data, Model, Utils } from "@singularsystems/neo-core";
import { AxiosPromise } from "axios";
import { injectable } from "inversify";
import { AppService, Types } from "../../App/Services/AppService";
import FileTypeSearchCriteria from "../FileSpecConfigurations/Models/Queries/FileTypeSearchCriteria";
import StaticExportFileSpecPartialLookup from "../FileSpecConfigurations/Models/Lookups/StaticExportFileSpecPartialLookup";
import StaticExportFileSpecLookup from "../FileSpecConfigurations/Models/Lookups/StaticExportFileSpecLookup";
import CreateExportFileSpecCommand from "../FileSpecConfigurations/Models/Commands/CreateExportFileSpecCommand";
import CommandResult from "../../Common/Models/CommandResult";
import UpdateExportFileSpecCommand from "../FileSpecConfigurations/Models/Commands/UpdateExportFileSpecCommand";

export interface IStaticExportFileSpecApiClient {
    getExportFileSpecPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileTypeSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticExportFileSpecPartialLookup>>>;
    getExportFileSpecById(query: number): AxiosPromise<StaticExportFileSpecLookup>;
    addNewExportFileSpec(command: Model.PlainObject<CreateExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateExportFileSpec(command: Model.PlainObject<UpdateExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    getExportFileSpecDropdownList(searchCriteria: string, staticServiceProviderFileGroupingId?: number): AxiosPromise<Array<Model.PlainObject<StaticExportFileSpecLookup>>>;
}

@injectable()
export default class StaticExportFileSpecApiClient extends Data.ApiClientBase implements IStaticExportFileSpecApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticExportFileSpec`)
    }

    public getExportFileSpecPagedList(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<FileTypeSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticExportFileSpecPartialLookup>>> {
        return this.axios.get(`${this.apiPath}/GetExportFileSpecPagedList?${Utils.getQueryString(payload)}`);
    }
    
    public getExportFileSpecById(query: number): AxiosPromise<StaticExportFileSpecLookup> {
        return this.axios.get(`${this.apiPath}/GetExportFileSpecById`, { params: { staticExportFileSpecId: query } });
    }

    public addNewExportFileSpec(command: Model.PlainObject<CreateExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/AddNewExportFileSpec`, command);
    }

    public updateExportFileSpec(command: Model.PlainObject<UpdateExportFileSpecCommand>): AxiosPromise<Model.PlainObject<CommandResult>> {
        return this.axios.post(`${this.apiPath}/UpdateExportFileSpec`, command);
    }

    public getExportFileSpecDropdownList(searchCriteria: string, staticServiceProviderFileGroupingId?: number): AxiosPromise<Array<Model.PlainObject<StaticExportFileSpecLookup>>> {
        return this.axios.get(`${this.apiPath}/GetExportFileSpecDropdownList`, { params: { searchCriteria: searchCriteria, staticServiceProviderFileGroupingId: staticServiceProviderFileGroupingId }});
    }
}